<section class="mnt mnt-form table-page__card">

  <!-- Los dos pasos. Se puede volver al anterior tocándolo; hacia
       adelante se pasa con «Siguiente», que revisa lo que falta. -->
  <ol class="mnt-pasos" aria-label="Pasos para pedir mantenimiento">
    <li *ngFor="let p of PASOS; let i = index"
        class="mnt-pasos__paso"
        [class.es-actual]="p.id === paso"
        [class.es-hecho]="i < indice()">
      <button type="button" class="mnt-pasos__btn" (click)="irA(p.id)"
              [disabled]="i >= indice()"
              [attr.aria-current]="p.id === paso ? 'step' : null">
        <span class="mnt-pasos__num" aria-hidden="true">
          <span class="material-icons" *ngIf="i < indice(); else numero">check</span>
          <ng-template #numero>{{ i + 1 }}</ng-template>
        </span>
        <span class="mnt-pasos__txt">{{ p.texto }}</span>
      </button>
    </li>
  </ol>

  <!-- ==================== 1. Detalles y fotos ====================
       Norman (15/10/2026): «quita el paso 1» y después «solo será el
       asunto, lo urgente, la evidencia y el teléfono». Ya no se pide el
       tipo de problema ni el lugar: el asunto puede decir dónde. -->
  <div class="mnt-form__cuerpo" *ngIf="paso === 'detalle'">
    <h2 class="mnt-form__titulo">Cuéntanos qué pasa</h2>

    <mat-form-field appearance="outline" class="table-page__field mnt-campo-mat" subscriptSizing="dynamic">
      <mat-label class="mnt-lbl--req">Asunto</mat-label>
      <textarea id="mntDesc" matInput rows="4" maxlength="2000" aria-label="Asunto"
                placeholder="Qué falla, dónde y desde cuándo. Ej. Gotea el lavabo del baño de la planta baja."
                [(ngModel)]="descripcion" name="descripcion"></textarea>
      <mat-hint align="end">{{ descripcion.length }} / 2000</mat-hint>
    </mat-form-field>

    <label class="mnt-lbl mnt-lbl--req">¿Qué tan urgente es?</label>
    <div class="mnt-urg" role="radiogroup" aria-label="Urgencia">
      <button type="button" class="mnt-urg__op" *ngFor="let u of URGENCIAS"
              role="radio" [attr.aria-checked]="urgencia === u.valor"
              [attr.data-u]="u.valor"
              [class.es-activa]="urgencia === u.valor"
              (click)="urgencia = u.valor">
        <span class="material-icons" aria-hidden="true">{{ u.icono }}</span>
        <span class="mnt-urg__txt"><b>{{ u.texto }}</b><small>{{ u.ayuda }}</small></span>
      </button>
    </div>

    <div class="mnt-fila">
      <div class="mnt-campo mnt-campo--fotos">
        <span class="mnt-lbl">Evidencia <span class="mnt-lbl__nota">fotos, opcional · hasta {{ MAX_FOTOS }}</span></span>
        <label class="mnt-soltar" [class.es-encima]="arrastrando"
               (dragover)="$event.preventDefault(); arrastrando = true"
               (dragleave)="arrastrando = false"
               (drop)="soltarFotos($event)"
               *ngIf="fotos.length < MAX_FOTOS">
          <span class="material-icons" aria-hidden="true">add_a_photo</span>
          <span><b>Agrega fotos</b> o arrástralas aquí</span>
          <small>JPG, PNG o WEBP · hasta 10 MB cada una</small>
          <input type="file" multiple [attr.accept]="ACEPTADAS" (change)="eligeFotos($event)" hidden />
        </label>
        <div class="mnt-fotos" *ngIf="fotos.length">
          <figure class="mnt-foto" *ngFor="let f of fotos; let i = index">
            <img [src]="f.vista" [alt]="f.archivo.name" />
            <figcaption>{{ tamano(f.archivo.size) }}</figcaption>
            <button type="button" class="mnt-foto__x" (click)="quitaFoto(i)"
                    [attr.aria-label]="'Quitar ' + f.archivo.name" title="Quitar">
              <span class="material-icons" aria-hidden="true">close</span>
            </button>
          </figure>
        </div>
      </div>

      <div class="mnt-campo mnt-campo--tel">
        <label class="mnt-lbl" for="mntTel">Teléfono o extensión <span class="mnt-lbl__nota">opcional</span></label>
        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <input id="mntTel" matInput type="tel" maxlength="20"
                 placeholder="Por si hay que preguntarte algo"
                 [(ngModel)]="telefono" name="telefono" autocomplete="off" />
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- ==================== 2. Revisar y enviar ==================== -->
  <div class="mnt-form__cuerpo" *ngIf="paso === 'revisar'">
    <h2 class="mnt-form__titulo">Revisa y envía</h2>

    <div class="mnt-resumen">
      <div class="mnt-resumen__cab">
        <span class="mnt-cat mnt-cat--grande" aria-hidden="true">
          <span class="material-icons">handyman</span>
        </span>
        <b class="mnt-resumen__que">Asunto</b>
        <span class="mnt-urgencia" [ngClass]="'es-' + (urgencia || '').toLowerCase()">
          {{ urgenciaElegida?.texto }}
        </span>
      </div>
      <p class="mnt-resumen__desc">{{ descripcion }}</p>
      <dl class="mnt-resumen__datos">
        <div *ngIf="yo"><dt>A nombre de</dt><dd>{{ yo }}</dd></div>
        <div><dt>Teléfono</dt><dd>{{ telefono.trim() || '—' }}</dd></div>
        <div><dt>Evidencia</dt><dd>{{ fotos.length ? fotos.length + (fotos.length === 1 ? ' foto' : ' fotos') : 'Ninguna' }}</dd></div>
      </dl>
      <div class="mnt-fotos mnt-fotos--chicas" *ngIf="fotos.length">
        <figure class="mnt-foto" *ngFor="let f of fotos"><img [src]="f.vista" [alt]="f.archivo.name" /></figure>
      </div>
    </div>

    <p class="mnt-aviso">
      <span class="material-icons" aria-hidden="true">mark_email_read</span>
      Le llega al equipo de mantenimiento. Te avisamos por correo cuando la tomen y cuando quede resuelta;
      entonces tú confirmas que quedó bien.
    </p>
  </div>

  <!-- Lo que falta para avanzar, cuando ya se intentó. Los botones van
       arriba, en el encabezado (ver #acciones). -->
  <footer class="mnt-form__pie" *ngIf="intento && falta">
    <span class="mnt-falta" role="alert">
      <span class="material-icons" aria-hidden="true">info_outline</span>{{ falta }}
    </span>
  </footer>
</section>

<!-- ==================== Botones ====================
     Van arriba, en el encabezado de «Solicitudes», como en
     Capacitación (15/10/2026): el concentrador pinta esta plantilla ahí.
     En el primer paso «Cancelar» hace lo que hacía «Cambiar de tipo»:
     regresa a las tarjetas; en el segundo, «Atrás». -->
<ng-template #acciones>
  <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="enviando"
          (click)="atras()">{{ paso === 'detalle' ? 'Cancelar' : 'Atrás' }}</button>
  <button type="button" class="app-form-btn app-form-btn--primary" *ngIf="paso !== 'revisar'"
          (click)="siguiente()">Siguiente</button>
  <button type="button" class="app-form-btn app-form-btn--primary" *ngIf="paso === 'revisar'"
          [disabled]="enviando" (click)="enviar()">{{ enviando ? 'Enviando…' : 'Enviar solicitud' }}</button>
</ng-template>
